"use strict";

var _classCallCheck = require("/Users/ganjarhadiatna/Projects/React/erxes-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ganjarhadiatna/Projects/React/erxes-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ganjarhadiatna/Projects/React/erxes-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ganjarhadiatna/Projects/React/erxes-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ganjarhadiatna/Projects/React/erxes-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Base = require("../styles/Base");

var _autosize = _interopRequireDefault(require("autosize"));

var InlineInputController = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(InlineInputController, _react$default$Compon);

  var _super = _createSuper(InlineInputController);

  function InlineInputController() {
    var _this;

    _classCallCheck(this, InlineInputController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "onFocus", function (e) {
      return e.target.select();
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "onMouseDown", function (e) {
      if (document.activeElement != e.target) {
        e.preventDefault();

        _this.refInput.focus();
      }
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "onBlur", function () {
      _this.updateValue();
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (e.keyCode == 13) {
        _this.refInput.blur();

        e.preventDefault();
      }

      if (e.keyCode == 27) {
        _this.setValue(_this.props.value);

        _this.refInput.blur();

        e.preventDefault();
      }

      if (e.keyCode == 9) {
        if (_this.getValue().length == 0) {
          _this.props.onCancel();
        }

        _this.refInput.blur();

        e.preventDefault();
      }
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "getValue", function () {
      return _this.refInput.value;
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "setValue", function (value) {
      return _this.refInput.value = value;
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "updateValue", function () {
      if (_this.getValue() != _this.props.value) {
        _this.props.onSave(_this.getValue());
      }
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "setRef", function (ref) {
      _this.refInput = ref;

      if (_this.props.resize != 'none') {
        (0, _autosize.default)(_this.refInput);
      }
    });
    return _this;
  }

  _createClass(InlineInputController, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setValue(nextProps.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          border = _this$props.border,
          value = _this$props.value,
          placeholder = _this$props.placeholder;
      return _react.default.createElement(_Base.InlineInput, {
        ref: this.setRef,
        border: border,
        onMouseDown: this.onMouseDown,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        placeholder: value.length == 0 ? undefined : placeholder,
        defaultValue: value,
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: "false",
        dataGramm: "false",
        rows: 1,
        autoFocus: autoFocus
      });
    }
  }]);

  return InlineInputController;
}(_react.default.Component);

InlineInputController.propTypes = {
  onSave: _propTypes.default.func,
  border: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  resize: _propTypes.default.oneOf(['none', 'vertical', 'horizontal'])
};
InlineInputController.defaultProps = {
  onSave: function onSave() {},
  placeholder: '',
  value: '',
  border: false,
  autoFocus: false,
  resize: 'none'
};
var _default = InlineInputController;
exports.default = _default;